import { FormikErrors } from "formik"

export enum ValidationErrorMessages {
    DUPLICATE_FILE_NAME = "File names must be unique",
    MISSING_FILE_NAME = "Filename is required",
    MISSING_SOURCE_TEXT = "Source text is required",
    OVERSIZED_SOURCE_TEXT = "Source text cannot exceed 3000 characters",
    OVERSIZED_TARGET_TEXT = "Target text cannot exceed 3500 characters"
}

interface FormFields {
    // These hold either form values or validation errors
    name: string
    source: string
    target?: string
}
export interface FormErrorFields {
    // these don't hold values, only used for operation errors
    sourceAudioError?: undefined
    targetAudioError?: undefined
    translationError?: undefined
    fileNameError?: undefined
    // rowIcon is used when no specific form field shows an error, but you want
    //     to present one generically
    rowIcon?: undefined
}

export type FormValues = FormFields & FormErrorFields

export interface InitialErrors {
    [index: number]: FormikErrors<FormValues>
}

export interface ServerOperationErrors {
    [itemId: number]: FormikErrors<FormErrorFields>
}
